import { render, staticRenderFns } from "./DatepickerSidebar.vue?vue&type=template&id=d182ba14&scoped=true&"
import script from "./DatepickerSidebar.vue?vue&type=script&lang=js&"
export * from "./DatepickerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DatepickerSidebar.vue?vue&type=style&index=0&id=d182ba14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d182ba14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
